<form class="form hide-mobile hide-tablet">
  <div class="container">
    <!-- FORM INPUTS -->
    <div class="row is-flex">
      <div class="col s12 login-wrapper">
        <button
          (click)="onLogin()"
          cdkFocusInitial
          class="btn btn-primary"
          name="login"
          type="button"
          [disabled]="pending$ | async"
          style="margin-bottom: 12px; width: 250px; margin-top: 10px"
        >
          <!-- style="width:  30px; margin-bottom: 12px;"-->
          Login
          <fa-icon *ngIf="pending$ | async" icon="spinner" [spin]="true"></fa-icon>
        </button>
      </div>
    </div>
    <!-- INVALID CREDENTIALS MESSAGE -->
    <ng-container *ngIf="(error$ | async) && (error$ | async) !== 'PASSWORD_EXPIRED'">
      <div class="row is-flex">
        <div class="col m4 s10">
          <span class="text-semibold text-block text-warn mb-20 error-message">
            <fa-icon icon="exclamation-triangle"></fa-icon> Email or password are invalid, please try again.
          </span>
        </div>
      </div>
    </ng-container>
  </div>
</form>
